<template>
  <span v-html="displayAddress" />
</template>

<script>
import _ from 'lodash'

export default {
  name: 'AddressDisplay',
  props: {
    address1: String,
    address2: String,
    suburb: String,
    postcode: String,
    state: String,
    country: String,

    singleLine: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    displayAddress() {
      let line = _.compact([this.suburb, this.postcode, this.state]).join(', ')
      let addressList = _.compact([this.address1, this.address2, line, this.country])

      return addressList.join(this.singleLine ? ', ' : '<br />')
    }
  }
}
</script>
